import { render, staticRenderFns } from "./TeAbout.vue?vue&type=template&id=0422d58b"
import script from "./TeAbout.vue?vue&type=script&lang=js"
export * from "./TeAbout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports